import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App, { client } from "./App";
import * as Sentry from "@sentry/react";
import { PullToRefreshProvider } from "./core/pull-to-refresh-provider";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "@sentry/react";
import { PackProvider } from "./Routes/boss/context/pack";
import { CartProvider } from "./core/cart";
import { LocationProvider } from "./core/location-provider";
import { AuthProvider } from "./core/auth";
import AmplitudeContextProvider from "./core/amplitude";
import { ApolloProvider } from "@apollo/client";
import { UserProvider } from "./core/user-context";
import { HelmetProvider } from "react-helmet-async";

// Start of Selection
if (process.env.REACT_APP_NODE_ENV !== "dev") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ApolloProvider client={client}>
        <AmplitudeContextProvider>
          <AuthProvider>
            <LocationProvider>
              <CartProvider>
                <PackProvider>
                  <UserProvider>
                    <PullToRefreshProvider>
                      {/* <GlobalStyle /> */}
                      <ErrorBoundary>
                        <ToastContainer />
                        <App />
                      </ErrorBoundary>
                    </PullToRefreshProvider>
                  </UserProvider>
                </PackProvider>
              </CartProvider>
            </LocationProvider>
          </AuthProvider>
        </AmplitudeContextProvider>
      </ApolloProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
